import { ErrorMessage } from "@hookform/error-message"
import * as React from "react"



const ErrorMessageContainer = ({ children, darkMode = false }) => (
    <small
        className=" spacing-box form-control-error d-inline-block text-danger"
        style={{ color: darkMode ? "#FFFFFF" : "#FF0048" }}
    >
        {children}
    </small>
)

export const ErrorMsg = ({ errors, name, darkMode }) => (
    <ErrorMessage
        errors={errors}
        name={name}
        as={<ErrorMessageContainer darkMode={darkMode} />}
        data-testid="error-mensaje"
    />
)
